import React from "react";
import { Box, Typography, Skeleton } from "@mui/material";
import { T } from "theme/tokens";

export default function Kpi({ label, value, sub, loading, tone = T.ink, sx }) {
  return (
    <Box sx={{ px: 2, py: 1.6, ...sx }}>
      <Typography
        sx={{
          fontSize: "0.65rem",
          fontWeight: 600,
          color: T.muted,
          textTransform: "uppercase",
          letterSpacing: "0.07em",
          mb: 0.4,
        }}
      >
        {label}
      </Typography>

      {loading ? (
        <Skeleton width={70} height={28} />
      ) : (
        <Typography
          sx={{
            fontSize: "1.45rem",
            fontWeight: 700,
            color: tone,
            lineHeight: 1.1,
            // Numbers that change on refresh must not make the row jitter.
            fontVariantNumeric: "tabular-nums",
            letterSpacing: "-0.01em",
          }}
        >
          {value}
        </Typography>
      )}

      {sub && (
        <Typography
          sx={{
            fontSize: "0.7rem",
            color: T.subtle,
            mt: 0.3,
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {sub}
        </Typography>
      )}
    </Box>
  );
}
